module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.targetCssClasses,
    attrs: {
      "id": _vm.targetId
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9631fc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/PlotlyJS/BasicChart.vue
// module id = 674
// module chunks = 0